var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n    .mic-st0{fill:#FFFFFF;}\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "mic-st0",
    d: "M256,300.4L256,300.4c25.3,0,45.7-20.5,45.7-45.7v-91.4c0-25.3-20.5-45.7-45.7-45.7h0       c-25.3,0-45.7,20.5-45.7,45.7v91.4C210.3,280,230.7,300.4,256,300.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "mic-st0",
    d: "M343.7,256c0-6.4-5.3-11.5-11.7-11.3c-6.2,0.2-11,5.5-11,11.7c-0.2,35.7-29.3,64.6-65,64.6s-64.8-29-65-64.6       c0-6.2-4.8-11.6-11-11.7c-6.4-0.2-11.7,5-11.7,11.3c0,39.6,26.4,73.2,62.6,84.1c8.2,2.5,13.8,10.1,13.8,18.7v28.3       c0,6.2,4.9,11.6,11.1,11.7c6.4,0.1,11.6-5,11.6-11.3v-28.7c0-8.6,5.6-16.3,13.8-18.7C317.3,329.2,343.7,295.6,343.7,256z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMic);
export default __webpack_public_path__ + "static/media/mic.950695596d4891b54a698cb32cf6eb42.svg";
export { ForwardRef as ReactComponent };